export function OnePiece(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      {}
      <path
        fill="currentColor"
        d="m15.8 18.5l6 1.6l-.4 1.9l-9.4-2.5L2.6 22l-.5-1.9l6-1.6L2 16.9l.5-1.9l9.4 2.5l9.4-2.5l.5 1.9zM9.5 6C8.7 6 8 6.7 8 7.5S8.7 9 9.5 9S11 8.3 11 7.5S10.3 6 9.5 6m5 0c-.8 0-1.5.7-1.5 1.5S13.7 9 14.5 9S16 8.3 16 7.5S15.3 6 14.5 6M13 11l-1-2l-1 2zM12 1C8.1 1 5 4.1 5 8c0 1.9.8 3.6 2 4.9V16h10v-3.1c1.2-1.3 2-3 2-4.9c0-3.9-3.1-7-7-7m3 11v2h-1v-2h-1v2h-2v-2h-1v2H9v-2c-1.2-.9-2-2.3-2-4c0-2.8 2.2-5 5-5s5 2.2 5 5c0 1.6-.8 3.1-2 4"
      />
    </svg>
  );
}
